// applicationsFiltersSlice.ts
import { IFiltersList } from "@/src/types/applicationOnline";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ApplicationsFiltersState {
  actualOfficeTable: string;
  filterStatus: string;
  searchQuery: string;
  filterParams: IFiltersList | null;
  filterResults: Record<string, string[] | string | null>;
}

const initialState: ApplicationsFiltersState = {
  actualOfficeTable: "ALL",
  filterStatus: "All",
  searchQuery: "",
  filterParams: null,
  filterResults: {},
};

const applicationsFiltersSlice = createSlice({
  name: "applicationsFilters",
  initialState,
  reducers: {
    setActualOfficeTable(state, action: PayloadAction<string>) {
      state.actualOfficeTable = action.payload;
    },
    setFilterStatus(state, action: PayloadAction<string>) {
      state.filterStatus = action.payload;

      state.filterResults = {
        ...state.filterResults,
        status: action.payload === "All" ? null : [action.payload],
      };
    },
    setSearchQuery(state, action: PayloadAction<string>) {
      state.searchQuery = action.payload;
      state.filterResults = {
        ...state.filterResults,
        query: state.searchQuery,
      };
      console.log(state.filterResults);
    },
    setFilterResults(state, action: PayloadAction<Record<string, string[] | string | null>>) {
      state.filterResults = action.payload;
    },
    updateFilterResult(
      state,
      action: PayloadAction<{ key: string; value: string[] | string | null }>
    ) {
      state.filterResults = {
        ...state.filterResults,
        [action.payload.key]: action.payload.value,
      };
    },
    // clearFilterResults(state) {
    //   state.filterResults = {};
    // },
  },
});

export const {
  setActualOfficeTable,
  setSearchQuery,
  setFilterStatus,
  setFilterResults,
  updateFilterResult,
  // clearFilterResults,
} = applicationsFiltersSlice.actions;

export default applicationsFiltersSlice.reducer;
